export default __webpack_public_path__ + "static/media/Rakesh.84a33ee8.png";